import { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: 'system',
    name: 'system',
    children: [
      {
        path: 'dict',
        name: 'system_dict',
        component: () => import('@/layout/routerView.vue'),
        redirect: '/system/dict/category',
        meta: { title: '字典管理', order: 40 },
        children: [
          {
            path: 'nature',
            name: 'system_dict_nature',
            component: () => import('@/views/Accident/Nature/index.vue'),
            meta: { title: '事故性质', order: 50 }
          }
        ]
      }
    ]
  },
  {
    path: 'accident',
    name: 'accident',
    component: () => import('@/layout/routerView.vue'),
    redirect: '/accident/list',
    meta: { title: '事故管理', icon: 'svg:menu-accident', order: 40 },
    children: [
      {
        path: 'list',
        name: 'accident_list',
        component: () => import('@/views/Accident/List/index.vue'),
        meta: { title: '事故列表' }
      }
    ]
  }
]

export default routes
